<template>
  <div class=" o_list">   
    <van-nav-bar
      class="bar"
      title="退货单"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    />
    <!-- <div
      class="name list"
      @click="go"
    >
      <div class="centen">       
      新建退货申请单
      </div>
      
    </div> -->
    <div
    @click="go1"
      class="name list"
    >
      <div class="centen">
    查看退货单
      </div>
      <!-- <div class="jian">
        <van-icon name="arrow" />
      </div> -->
    </div>
    <!-- <div class="zu">
        *注：只能退最近三个月的货物，更早的请联系业务员
    </div> -->

      <div class="but">
        <van-button
          type="danger"
          size="large"
          @click="onClickLeft"
        >退出</van-button>
      </div>
  </div>
</template>
<script>
import Vue from 'vue'
// import List from './child/list'
import { NavBar, Tab, Tabs, List, Cell, Search, Dialog, Toast, CountDown } from 'vant'

Vue.use(NavBar).use(Tabs).use(Tab).use(Cell).use(List).use(Search).use(Dialog).use(CountDown)
export default {
  created () {
    

  },
  mounted () {
   
  },
  beforeDestroy () {
    


  },

  data () {
    return {
      value: '',
      title: '订单列表',
      nav: ['未结算', '已提交', '待发货', '发货中','已完成','已取消'],
      active: 1,
      states: true,
      list: [],
      loading: false,
      finished: false,
      page: 1,
    }
  },
  methods: {
    
    onClickLeft () {
      this.$router.push('my')
    },
    
    go(){
      this.$router.push('tui1')

    },
     go1(){
      this.$router.push('tui2')

    },
  },
  components: {
    // List
  }
}
</script>
<style lang="less" scoped>

.o_list {
  padding-top: 1.2rem;
  .bar {
    z-index: 99;
  }
}
.zu{
    color: rgb(245, 9, 9);
    text-align: center;
}
.name {
  display: flex;
  height: 2.08rem;
  background-color: #fff;
  padding: 0.2rem;
  border-bottom: 1px solid #eee;
  .tu {
    flex: 0.3;
    img {
      width: 1.52rem;
    }
  }
  .centen {
    flex: 1;
    padding-top: 0.2rem;
    .top {
      font-size: 0.4rem;
      color: #333;
    }
    .bottom {
      padding-top: 0.2rem;
      font-size: 0.26rem;
      color: #999;
    }
  }
  .jian {
    flex: 0.13;
    padding-top: 0.6rem;
    font-size: 0.5rem;
    color: #e3e3e3;
  }
  .renz{
    flex: 0.33;
    padding-top: 0;
  }
}
.list {
  padding-left: 0.5rem;
  height: 1.3rem;
  .centen {
    font-size: 0.38rem;
  }
  .jian {
    flex: 0.1;
    padding-top: 0.2rem;
  }
}
.but{
    width: 100%;
    position: fixed;
    bottom: 0;
}
</style>
